import {RouteRecordRaw} from "vue-router";
import HeaderView from "@/views/share/HeaderView.vue";
import LayoutView from "@/views/share/LayoutView.vue";
import {UserAgent} from "@/model/user_agent";
import branch from "@/views/brand/branch";

export default <Array<RouteRecordRaw>>[
    {
        path: '/brand',
        name: '',
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: ':brand_id',
                meta: {auth: true},
                beforeEnter: (to, from, next) => {
                    (to.meta.agent as UserAgent).meta.brands.forEach(b => {
                        if (b.brand_id == to.params.brand_id) {
                            to.meta.brand = b
                        }
                    })
                    if (to.meta.brand) next()
                    else next('/')
                },
                components: {
                    default: () => import(/* webpackChunkName: "brand" */ './BrandView.vue'),
                    header: HeaderView,
                },
            }
        ]
    },
    {
        path: '/brand/:brand_id/branch',
        meta: {auth: true},
        component: LayoutView,
        children: branch
    }
]
